export const apiDomain = 'https://atacloud.es/ata-api/public/api/';//'https://api.atacloud.es/api/';
export const siteName = 'ATA';
export const login = apiDomain + '/login';
export const isDevelop = (process.env.NODE_ENV !== 'production');